document.addEventListener('DOMContentLoaded', () => {
  const mask  = document.getElementById('testimonial-mask');
  const cards = Array.from(document.querySelectorAll('#testimonial-track .single-testimonial'));
  const prev  = document.querySelector('#testimonials .arrow-nav .prev');
  const next  = document.querySelector('#testimonials .arrow-nav .next');

  if (!mask || !cards.length) return;

  let index = 0;

  const clamp = (n, min, max) => Math.max(min, Math.min(n, max));
  const scrollToIndex = (i) => {
    index = clamp(i, 0, cards.length - 1);
    cards[index].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
  };

  // Keep index in sync as the user swipes
  const io = new IntersectionObserver((entries) => {
    // pick the most visible card in the mask viewport
    let best = { idx: index, ratio: 0 };
    for (const e of entries) {
      if (e.isIntersecting && e.intersectionRatio > best.ratio) {
        best = { idx: cards.indexOf(e.target), ratio: e.intersectionRatio };
      }
    }
    if (best.ratio > 0) index = best.idx;
  }, {
    root: mask,
    threshold: [0.25, 0.5, 0.75, 1]
  });

  cards.forEach(card => io.observe(card));

  // Arrow controls
  prev?.addEventListener('click', () => scrollToIndex(index - 1));
  next?.addEventListener('click', () => scrollToIndex(index + 1));

  // Keyboard (optional): left/right when mask is focused
  mask.setAttribute('tabindex', '0');
  mask.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowLeft')  { e.preventDefault(); scrollToIndex(index - 1); }
    if (e.key === 'ArrowRight') { e.preventDefault(); scrollToIndex(index + 1); }
  });
});
